import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, FileText, Users, Lock } from 'lucide-react';

const TermsPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            {/* Header */}
            <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
                <div className="max-w-4xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <Link 
                                to="/login" 
                                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                            >
                                <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-400" />
                            </Link>
                            <div className="flex items-center gap-2">
                                <FileText className="w-6 h-6 text-[#8A78F0]" />
                                <h1 className="text-xl font-bold text-gray-900 dark:text-white">Syarat & Ketentuan</h1>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <Shield className="w-5 h-5 text-green-500" />
                            <span className="text-sm text-gray-600 dark:text-gray-400">Terakhir diperbarui: {new Date().toLocaleDateString('id-ID')}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 py-8">
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8">
                    
                    {/* Introduction */}
                    <div className="mb-8">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                            Selamat Datang di LakuKelas
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                            LakuKelas adalah platform asisten guru cerdas yang dirancang untuk membantu guru dalam mengelola administrasi kelas dengan lebih mudah dan efisien. Dengan menggunakan layanan kami, Anda menyetujui syarat dan ketentuan yang dijelaskan di bawah ini.
                        </p>
                    </div>

                    {/* Sections */}
                    <div className="space-y-8">
                        {/* Penggunaan Layanan */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                                <Users className="w-5 h-5 text-[#8A78F0]" />
                                1. Penggunaan Layanan
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• LakuKelas hanya dapat digunakan oleh guru yang berwenang dan memiliki akun yang valid.</p>
                                <p>• Anda bertanggung jawab untuk menjaga kerahasiaan akun dan kata sandi Anda.</p>
                                <p>• Dilarang menggunakan layanan untuk tujuan yang melanggar hukum atau merugikan pihak lain.</p>
                                <p>• Kami berhak membatasi atau menangguhkan akses jika terjadi pelanggaran.</p>
                            </div>
                        </section>

                        {/* Privasi dan Keamanan */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                                <Lock className="w-5 h-5 text-[#8A78F0]" />
                                2. Privasi dan Keamanan
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Data pribadi dan akademik siswa akan dijaga kerahasiaannya sesuai dengan kebijakan privasi kami.</p>
                                <p>• Kami menggunakan teknologi enkripsi untuk melindungi data yang tersimpan.</p>
                                <p>• Data hanya akan digunakan untuk keperluan administrasi pendidikan yang sah.</p>
                                <p>• Kami tidak akan membagikan data kepada pihak ketiga tanpa izin yang jelas.</p>
                            </div>
                        </section>

                        {/* Tanggung Jawab Pengguna */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                                <Shield className="w-5 h-5 text-[#8A78F0]" />
                                3. Tanggung Jawab Pengguna
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Anda bertanggung jawab atas keakuratan data yang dimasukkan ke dalam sistem.</p>
                                <p>• Dilarang memasukkan data palsu atau menyesatkan.</p>
                                <p>• Anda harus melaporkan setiap aktivitas mencurigakan yang terjadi pada akun Anda.</p>
                                <p>• Penggunaan sistem harus sesuai dengan etika profesi guru.</p>
                            </div>
                        </section>

                        {/* Batasan Layanan */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                4. Batasan Layanan
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Layanan dapat mengalami gangguan teknis yang tidak dapat dihindari.</p>
                                <p>• Kami tidak bertanggung jawab atas kerugian yang timbul dari gangguan layanan.</p>
                                <p>• Fitur dan layanan dapat berubah atau dihentikan sesuai kebijakan kami.</p>
                                <p>• Pengguna akan diberitahu terlebih dahulu untuk perubahan yang signifikan.</p>
                            </div>
                        </section>

                        {/* Hak Kekayaan Intelektual */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                5. Hak Kekayaan Intelektual
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Semua hak kekayaan intelektual terkait LakuKelas tetap menjadi milik kami.</p>
                                <p>• Dilarang menyalin, memodifikasi, atau mendistribusikan konten tanpa izin.</p>
                                <p>• Data yang dimasukkan pengguna tetap menjadi hak pengguna tersebut.</p>
                            </div>
                        </section>

                        {/* Pembatasan Tanggung Jawab */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                6. Pembatasan Tanggung Jawab
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• LakuKelas disediakan "sebagaimana adanya" tanpa jaminan apapun.</p>
                                <p>• Kami tidak bertanggung jawab atas kerugian tidak langsung atau konsekuensial.</p>
                                <p>• Tanggung jawab kami dibatasi sesuai dengan hukum yang berlaku.</p>
                            </div>
                        </section>

                        {/* Perubahan Syarat */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                7. Perubahan Syarat dan Ketentuan
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Kami berhak mengubah syarat dan ketentuan ini sewaktu-waktu.</p>
                                <p>• Perubahan akan diumumkan melalui aplikasi atau email.</p>
                                <p>• Penggunaan berkelanjutan setelah perubahan berarti Anda menyetujui syarat baru.</p>
                            </div>
                        </section>

                        {/* Hukum yang Berlaku */}
                        <section>
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                8. Hukum yang Berlaku
                            </h3>
                            <div className="space-y-3 text-gray-600 dark:text-gray-400">
                                <p>• Syarat dan ketentuan ini tunduk pada hukum Republik Indonesia.</p>
                                <p>• Sengketa akan diselesaikan melalui musyawarah terlebih dahulu.</p>
                                <p>• Jika tidak tercapai kesepakatan, sengketa akan diselesaikan di pengadilan yang berwenang.</p>
                            </div>
                        </section>
                    </div>

                    {/* Contact Information */}
                    <div className="mt-12 p-6 bg-gray-50 dark:bg-gray-700 rounded-xl">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">
                            Hubungi Kami
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 mb-2">
                            Jika Anda memiliki pertanyaan tentang syarat dan ketentuan ini, silakan hubungi kami:
                        </p>
                        <div className="space-y-1 text-sm text-gray-600 dark:text-gray-400">
                            <p>📧 Email: balkhi005@gmail.com</p>
                            <p>📱 WhatsApp: +62 89522537711</p>
                            <p>🌐 Website: www.lakukelas.my.id</p>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700 text-center">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            © {new Date().getFullYear()} LakuKelas. Semua hak dilindungi.
                        </p>
                        <div className="mt-4 flex justify-center gap-4">
                            <Link 
                                to="/privacy" 
                                className="text-sm text-[#8A78F0] hover:underline"
                            >
                                Kebijakan Privasi
                            </Link>
                            <Link 
                                to="/login" 
                                className="text-sm text-[#8A78F0] hover:underline"
                            >
                                Kembali ke Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsPage; 